<template>
	<v-container>
		<v-row
			v-if="selectedItems.length > 0"
			class="d-flex align-center rounded-lg"
			:style="{background: elementBackgroundColor}"
		>
			<v-col cols="6" class="start">
				<span :style="{ color: elementTextColor }" class="element">
					{{ selectedItems.length }} item(s) selected
				</span>
			</v-col>
			<v-col cols="6" class="end delete">
				<v-btn
					@click="deleteSelection(selectedItems)"
					prepend-icon="mdi-delete"
					variant="outlined"
					:style="{ color: elementTextColor }"
					class="delete"
					>DELETE</v-btn
				>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col>
				<v-data-table
					:headers="headers"
					:items="keylist"
					:sort-by="[{ key: 'name', order: 'asc' }]"
					:items-per-page="5"
					:items-per-page-options="[
						{ value: 5, title: '5' },
						{ value: 10, title: '10' },
						{ value: 25, title: '25' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
					]"
					loading-text="Loading... Please wait"
					:multi-sort="true"
					:hover="true"
					:show-select="shouldShowSelect"
					v-model="selectedItems"
				>
					<template v-slot:top>
						<div class="d-flex align-center">
							<span class="font-weight-medium">Keys</span>
							<v-spacer></v-spacer>
							<v-dialog v-model="dialog" max-width="75%">
								<template v-slot:activator="{ props }">
									<v-btn variant="outlined" v-bind="props">New Key</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="font-weight-bold">{{ keyFormTitle }}</span>
									</v-card-title>
									<v-card-text>
										<v-container>
											<input type="hidden" v-model="editItem.id" />
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.name"
												label="Key Name"
											></v-text-field>
											<v-combobox
												class="w-auto"
												variant="outlined"
												:items="getKeyType()"
												v-model="editItem.keyTypeName"
												label="Key type"
											></v-combobox>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.value"
												label="Value"
											></v-text-field>
										</v-container>
									</v-card-text>
									<v-divider class="mt-5"></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn variant="text" @click="close">Cancel</v-btn>
										<v-btn
											color="primary"
											variant="text"
											@click="funSaveItem"
											:loading="loading"
											>Save</v-btn
										>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</div>
					</template>
					<template v-slot:[`item.typeId`]="{ item }">
						<td>{{ formatKeyType(item.typeId) }}</td>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-icon small @click="funEditItem(item)"
							>mdi-pencil</v-icon
						>
						<v-icon small @click="funDeleteditItem(item)"
							>mdi-delete</v-icon
						>
					</template>
					<template v-slot:no-data>
						<span>No Data Available</span>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
	CREATE_KEY,
	EDIT_KEY,
	REMOVE_KEY,
	REMOVE_KEYS,
} from "@/store/_actiontypes";

export default {
	data: () => ({
		loading: false,
		dialog: false,
		menu: false,
		selectedItems: [],
		headers: [
			{ title: "Id", key: "id", align: " d-none" },
			{ title: "Name", key: "name" },
			{ title: "Value", key: "value" },
			{ title: "Type", key: "typeId" },
			{ title: "Actions", key: "action", sortable: false, width: 50 },
		],
		editItem: {
			id: 0,
			name: "",
			value: "",
            keyTypeName: "DUKPT",
			typeId: 0,
		},
		defaulItem: {
			id: 0,
			name: "",
			value: "",
            keyTypeName: "DUKPT",
			typeId: 0,
		},
	}),

	computed: {
		...mapState({ keylist: (state) => state.keys.keylist }),
		keyFormTitle() {
			return this.editItem.id === 0 ? "New Key" : "Edit Key";
		},
		shouldShowSelect() {
			return this.keylist.length >= 1;
		},

		elementTextColor() {
			return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
		},
		elementBackgroundColor() {
			return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
		},
	},

	watch: {
		dialog(val) {
			val || this.close();
		},
		selectedItems(val) {
			this.selectedItems = val;
		},
	},
	methods: {
		...mapActions("keys", [CREATE_KEY, EDIT_KEY, REMOVE_KEY, REMOVE_KEYS]),
		funEditItem(item) {
			this.editItem = Object.assign({}, item);
			this.editItem.keyTypeName = this.formatKeyType(item.typeId);
			this.dialog = true;
		},

		funDeleteditItem(item) {
			confirm("Are you sure you want to delete this item?") &&
				this.REMOVE_KEY({ id: item.id });
		},

		deleteSelection() {
			const ids = [];
			for (var val in this.selectedItems) {
				ids.push(this.selectedItems[val]);
			}
			if (
				confirm(
					`Are you sure you want to delete ${ids.length} selected item(s)?`
				)
			) {
				this.REMOVE_KEYS({ ids: ids });
				this.selectedItems = [];
			}
		},

		close() {
			this.dialog = false;
			this.editItem = Object.assign({}, this.defaulItem);
		},

		funSaveItem() {
			this.loading = true;
			var key = this.editItem;
			key.typeId = this.getKeyTypeId(this.editItem.keyTypeName);

			if (key.id == 0) {
				this.CREATE_KEY({
					key,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.EDIT_KEY({
					key,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},

		formatKeyType(type) {
			var ret = type;
			var list = this.getKeyType();
			if (ret < list.length) {
				return list[ret];
			}
			return ret;
		},
		getKeyType() {
            return ["DUKPT", "MASTER SESSION"];
		},
		getKeyTypeId(type) {
			var list = this.getKeyType();
			return list.indexOf(type);
		},
	},
};
</script>

<style>
.element {
	padding: 10px;
	border: none;
	color:black;
}

.start {
	display: flex;
	justify-content: flex-start;
}

.end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.delete {
	cursor: pointer;
}
</style>
